import { EmptyState } from '../../../components/EmptyState';
import { Spinner } from '../../../components/Spinner';
import { useGetDraftBooksQuery } from '../api/booksApi';
import { BookType } from '../api/types';
import { BookRow } from './BookRow';

type DraftBooksProps = {
  isDraftPage: boolean;
  onDeletePress: (book: BookType) => void;
  onEditPress: (book: BookType) => void;
};

export const DraftBooks = ({ isDraftPage, onDeletePress, onEditPress }: DraftBooksProps) => {
  const { data: draftBooks, isLoading: loadingDraftBooks } = useGetDraftBooksQuery(undefined, {
    skip: !isDraftPage
  });

  if (loadingDraftBooks) {
    return (
      <div className="w-full h-[50vh] flex justify-center items-center">
        <Spinner />
      </div>
    );
  }
  return (
    <>
      {draftBooks && draftBooks.count > 0 ? (
        draftBooks?.results.map((book) => (
          <BookRow
            key={book.id}
            book={book}
            onDeletePress={onDeletePress}
            onEditPress={onEditPress}
          />
        ))
      ) : (
        <EmptyState text="No draft books found" />
      )}
    </>
  );
};
